import type { Texts } from '../useTexts'

export const createValidateBackupSubjectCustom = (
  texts: Texts,
  backupSubjectCustom: string | undefined,
  required: boolean,
) => {
  const maxLength = 50
  const backupSubjectCustomRequired = {
    id: 'backupSubjectCustomRequired',
    field: 'backupSubjectCustom',
    message: texts.requiredField,
    priority: 10,
  }

  const backupSubjectCustomMaxLengthError = {
    id: 'backupSubjectCustomMaxLengthError',
    field: 'backupSubjectCustom',
    message: texts.subjectTooLong(maxLength),
    priority: 9,
  }

  const requiredError = required && backupSubjectCustom?.trim().length === 0
  const maxLengthError = backupSubjectCustom && backupSubjectCustom.length > maxLength

  return {
    [backupSubjectCustomRequired.id]: requiredError ? backupSubjectCustomRequired : undefined,
    [backupSubjectCustomMaxLengthError.id]: maxLengthError
      ? backupSubjectCustomMaxLengthError
      : undefined,
  }
}
